import React, { useState } from "react";
import {
  Box,
  Button,
  Divider,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Text,
  VStack,
  useBreakpointValue,
  useToast,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../config/axiosInstance";

const Confirm = () => {
  const [otp, setOtp] = useState("");
  const toast = useToast();
  const navigate = useNavigate();
  const boxWidth = useBreakpointValue({ base: "90%", sm: "xs", md: "md" });

  const handleVerify = async () => {
    const phone = localStorage.getItem("resetPhone"); // ✅ Using phone now

    if (!phone) {
      toast({
        title: "Phone number not found",
        description: "Please go back and enter your phone number again.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      // ✅ Send phone + otp to backend
      await axiosInstance.post("/api/auth/verify-otp", {
        phone,
        otp,
      });

      toast({
        title: "OTP Verified",
        description: "Proceed to set a new password.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      localStorage.setItem("resetOtp", otp);
      navigate("/complete");
    } catch (error) {
      toast({
        title: "Verification Failed",
        description: error.response?.data?.message || "Invalid or expired OTP.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <Flex minH="100vh" bg="gray.50" justify="center" align="start" pt={16} px={2}>
      <Box
        bg="white"
        w={boxWidth}
        rounded="md"
        p={{ base: 5, md: 8 }}
        boxShadow="md"
      >
        <VStack spacing={4} align="stretch">
          <Heading
            fontSize={{ base: "xl", md: "2xl" }}
            fontWeight="bold"
            textAlign="center"
          >
            Confirm OTP
          </Heading>

          <Text fontSize="sm" textAlign="center" color="gray.600">
            Enter the OTP sent to your phone number
          </Text>

          <FormControl>
            <FormLabel fontSize="sm">OTP</FormLabel>
            <Input
              placeholder="Enter OTP"
              size="sm"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
          </FormControl>

          <Button
            size="sm"
            color="white"
            bg="#005738"
            _hover={{ bg: "#00462e" }}
            w="full"
            onClick={handleVerify}
            isDisabled={!otp}
          >
            Confirm
          </Button>

          <Divider />

          <Text fontSize="xs" textAlign="center" color="gray.600">
            Haven’t received your code?
          </Text>

          <Button
            variant="outline"
            colorScheme="blue"
            size="sm"
            fontSize="xs"
            w="full"
            onClick={() => {
              toast({
                title: "Resend not implemented",
                description: "Use the forgot password screen to resend the OTP.",
                status: "info",
                duration: 3000,
                isClosable: true,
              });
            }}
          >
            Resend Code
          </Button>
        </VStack>
      </Box>
    </Flex>
  );
};

export default Confirm;
